import React from 'react';
import { Button, Typography, Modal } from 'ui-kit';

interface IProps {
  visible: boolean;
  onCancel: () => void;
  logout: () => void;
}

const OwnerAlertModal = ({ visible, onCancel, logout }: IProps) => (
  <Modal
    visible={visible}
    footer={null}
    style={{ top: '20%' }}
    width="40%"
    maskStyle={{
      background: 'rgba(240, 239, 234, 0.5)',
      backdropFilter: 'blur(15px)',
    }}
    wrapClassName="Store_alert-modal"
    onCancel={onCancel}
  >
    <Typography variant="h5">You are in the shop preview</Typography>
    <p>To add items to your cart, check out, or see full guest view, log out of your store.</p>
    <Button onClick={logout} className="modalButton">
      Log Out
    </Button>
  </Modal>
);

export default OwnerAlertModal;
